import { render, staticRenderFns } from "./ActionsSelection.vue?vue&type=template&id=97f0ab64&scoped=true&"
import script from "./ActionsSelection.vue?vue&type=script&lang=js&"
export * from "./ActionsSelection.vue?vue&type=script&lang=js&"
import style0 from "./ActionsSelection.vue?vue&type=style&index=0&id=97f0ab64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f0ab64",
  null
  
)

export default component.exports